import { classNameGenerator } from "@/utils";
import styles from "./Steps.module.scss"
import Typography from "@/foundation/Typography/V2";
import { SVGSprite } from "@/components/Atoms";


const Steps = ({steps}) => {
    const cls = classNameGenerator(styles)
    
    return (
        <div className={cls("stepContainer")}>
            <div className={cls("stepWrapper")}>
                {
                    steps.map((_val, index) => {
                        return (
                            <div className={cls("stepContent")}>
                                <div className={cls("left")}>
                                    <div className={cls("counterWrapper")}>
                                        <div className={cls("count")}>{index + 1}</div>
                                    </div>
                                    <div className={cls("heading")}>
                                        {_val?.subTitle &&
                                            <Typography
                                                variant="heading6"
                                                className={cls("subTitle")}
                                                dangerouslySetInnerHTML={{ __html: _val?.subTitle }}
                                            />
                                        }
                                        <Typography
                                            variant="heading6"
                                            className={cls("title")}
                                            dangerouslySetInnerHTML={{ __html: _val?.title }}
                                        />
                                    </div>
                                </div>
                                <div className={cls("right")}>
                                    <div className={cls("content")}>
                                        {
                                            _val?.content.map((_val) => {
                                                return (
                                                    <div className={cls("contentBox")}>
                                                        <SVGSprite
                                                            icon="icon-list-check"
                                                            className={cls("icon")}
                                                        />
                                                        <Typography variant="paragraph1" className={cls("description")}>
                                                            {_val}
                                                        </Typography>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>

                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Steps;